module.exports = __webpack_public_path__ + "static/media/boletinNewaJunio.6be3378e.png";